/**
 * Singleton API client instance.
 *
 * Shared across all hooks and components to avoid creating
 * multiple Axios instances with duplicate interceptors.
 */

import { createApiClient, type ApiClient } from './client'

let apiClientInstance: ApiClient | null = null

/**
 * Get the singleton API client instance.
 * Creates the instance on first call, returns the same instance thereafter.
 */
export function getApiClient(): ApiClient {
  if (!apiClientInstance) {
    apiClientInstance = createApiClient()
  }
  return apiClientInstance
}

/**
 * Reset the singleton instance.
 * Useful for testing to ensure a fresh client between test runs.
 */
export function resetApiClient(): void {
  apiClientInstance = null
}
